import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { HttpRequestTracker } from './http-request-tracker';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(private readonly httpRequestTracker: HttpRequestTracker) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const handledRequest: Observable<HttpEvent<unknown>> = next
      .handle(request)
      .pipe(shareReplay(1));

    this.httpRequestTracker.add(request.url, handledRequest);

    return handledRequest;
  }
}
